module.exports = __webpack_public_path__ + "static/img/hb_60-min.ba4bff9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_60-min.png
// module id = TtQa
// module chunks = 1